function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M29 14.5c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5V7.7L9.8 24.4c-.1.1-.2.2-.4.2h-.2c-.2-.1-.4-.3-.4-.5V15H1.5c-.3 0-.5-.2-.5-.6 0-.3.2-.5.5-.5h7.9c.3 0 .5.2.5.5v7.9L21.1 5.6c.1-.2.4-.3.6-.2.2.1.3.3.3.5v8h6.5c.3 0 .5.3.5.6z"
})));